import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { EventsService } from 'src/app/services/events.service';

@Component({
  standalone: false,
  selector: 'app-active-event-modal-modal',
  templateUrl: './active-event-modal.component.html',
  styleUrls: ['./active-event-modal.component.scss'],
})
export class ActiveEventModalComponent implements OnInit {
  @Input() id: string;
  @Input() status: string;

  finalSubmissionArray = [];

  constructor(
    public modal: NgbActiveModal,
    private formBuilder: FormBuilder,
    private router: Router,
    private eventService: EventsService,
  ) {
  }

  ngOnInit(): void { }

  changeStatus() {
    this.finalSubmissionArray.push({
      eventId: this.id,
      isActive: this.status
    });
    this.eventService
      .activeDeactiveMainEvent(this.finalSubmissionArray[0])
      .subscribe((res) => {
        console.log(res);
        setTimeout(() => {
          this.modal.dismiss();
          window.location.reload();
        }, 1000);
      });
  }
}
